export default "__VITE_ASSET__TEu1nYp7__"